"use client"

import { isAxiosError } from "axios"
import {
  Button,
  Field,
  Input,
  useAsyncCallback,
  useNotice,
  VStack,
} from "@/components/ui"
import { CONSTANT } from "@/constant"
import { useForm } from "@/libs/react-hook-form"
import { replaceMessage } from "@/utils/string"

interface FieldValues {
  email: string
}

export function Form() {
  const {
    formState: { errors },
    handleSubmit,
    register,
    setAPIErrors,
  } = useForm<FieldValues>()
  const notice = useNotice()

  const [loading, onSubmit] = useAsyncCallback(
    (_fieldValues: FieldValues) => {
      try {
        notice({
          status: "success",
          title: replaceMessage(CONSTANT.MESSAGE.SUCCESS.SENT, "メール"),
        })
      } catch (e) {
        if (isAxiosError(e)) setAPIErrors(e)
      }
    },
    [],
    { loading: "page" },
  )

  return (
    <VStack as="form" noValidate onSubmit={handleSubmit(onSubmit)}>
      <Field.Root
        errorMessage={errors.email?.message}
        invalid={!!errors.email}
        label="メールアドレス"
        required
      >
        <Input autoComplete="email" {...register("email")} />
      </Field.Root>

      <Button type="submit" size="lg" loading={loading}>
        メールを送信
      </Button>
    </VStack>
  )
}
